import axios from 'axios'

/**
 * @desc updates Supplier Details
 */
export const updateDetails = (request) =>
  axios
    .put('/authenticated/credentials/details', request)
    .then((res) => res.data)

/**
 * @desc Updates Supplier Email
 */
export const updateEmail = (request) =>
  axios.put('/authenticated/credentials/email', request).then((res) => res.data)

/**
 * @desc Updates Supplier Password
 */
export const updatePassword = (request) =>
  axios
    .put('/authenticated/credentials/password', request)
    .then((res) => res.data)
